import type { Common } from '@libs/domain';
import type { CharacterCode, ImportType } from '@libs/enums';
import { characterCode } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';

export class MstImport
  implements Pick<Common['schema'], 'characterCode' | 'file' | 'importClass' | 'jobComment'>
{
  protected constructor(
    readonly file: File | null,
    readonly jobComment: string,
    readonly importClass: OrEmpty<ImportType>,
    readonly characterCode: OrEmpty<CharacterCode>,
  ) {}

  static baseInit() {
    return new MstImport(null, '', '', characterCode.enum.ms932);
  }
}

export class MstImportRaw
  implements Pick<Common['record'], 'characterCode' | 'file' | 'importClass' | 'jobComment'>
{
  protected constructor(
    readonly file: File | null,
    readonly jobComment: string,
    readonly importClass: string,
    readonly characterCode: string,
  ) {}

  static baseFromModel(file: File | null, mstImport: MstImport) {
    return new MstImportRaw(file, mstImport.jobComment, mstImport.importClass, mstImport.characterCode);
  }
}
